import { ListSubheader, MenuItem, TextField, InputAdornment } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MuiSelect from "@mui/material/Select";
import SearchIcon from "@mui/icons-material/Search";
import React, { useCallback, useMemo, useState, useRef } from 'react';
import { generateUniqueID } from "web-vitals/dist/modules/lib/generateUniqueID";

const Select = ({options, margin, fullWidth, label, loading, onChange, value,
                  optionValueKey, optionLabelKey, getOptionLabel,
                  required, filterOptions, reducerKey, searchable, ...props}) => {
  const uniqueId = useMemo(() => generateUniqueID(), []);
  const [searchText, setSearchText] = useState("");
  const searchInputRef = useRef(null);

  const _options = useMemo(() => {
    if(filterOptions) return (options || []).filter(filterOptions);
    return options || [];
  }, [options, filterOptions]);

  const optionsMap = useMemo(() => {
    return _options.reduce((acc, opt, i) => {
      acc[opt[optionValueKey]] = i;
      return acc;
    }, {});
  }, [_options, optionValueKey]);

  const _getOptionLabel = useCallback((item) => {
    if(getOptionLabel) return getOptionLabel(item);
    if(reducerKey == "protocolForm"){
      if(item[optionLabelKey].length == 2)
      return `0${item[optionLabelKey]}`;
    } 
    return item[optionLabelKey];
  }, [optionLabelKey, getOptionLabel])

  const filteredOptions = useMemo(() => {
    if (!searchable || !searchText) return _options;
    return _options.filter((opt) => {
      const labelText = _getOptionLabel(opt);
      if (!labelText) return false;
      return String(labelText).toLowerCase().includes(searchText.toLowerCase());
    });
  }, [_options, searchable, searchText, _getOptionLabel]);

  const menuProps = useMemo(() => {
    if (!searchable) return undefined;
    return {
      autoFocus: false,
      PaperProps: {
        sx: { maxHeight: 350 },
      },
    };
  }, [searchable]);

  return <FormControl fullWidth={fullWidth}>
    {label && <InputLabel id={`${uniqueId}-select`} required>{label}</InputLabel>}
    <MuiSelect
      labelId={`${uniqueId}-select`}
      margin={margin || "normal"}
      label={label}
      value={value || ""}
      onChange={(e) => {
        onChange(e.target.value, _options[optionsMap[e.target.value]])
      }}
      onOpen={() => setSearchText("")}
      MenuProps={menuProps}
      onKeyDown={searchable ? (e) => { e.stopPropagation(); } : undefined}
      {...props}
    >
      {searchable && (
        <ListSubheader sx={{ pt: 1, pb: 1 }}>
          <TextField
            size="small"
            autoFocus
            placeholder="Поиск..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            value={searchText}
            inputRef={searchInputRef}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
          />
        </ListSubheader>
      )}
      <MenuItem value="">
        <em>Нет выбора</em>
      </MenuItem>
      {filteredOptions.map(_ => (
        <MenuItem
          key={_[optionValueKey]}
          value={_[optionValueKey]}
          disabled={Boolean(_.disabled)}
        >
          {_getOptionLabel(_)}
        </MenuItem>
      ))}
    </MuiSelect>
  </FormControl>
};

Select.defaultProps = {
  optionValueKey: 'value',
  optionLabelKey: 'label',
};

export default Select;
